"use client";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { countries } from "./countryData";
import { VeBox, VeTypography } from "../../mui";

const DropDownIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      // style={{ marginRight: "10px", marginTop: "-1px" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.411 13.0896C9.73642 13.4151 10.2649 13.4151 10.5903 13.0896L15.5886 8.09132C15.914 7.76591 15.914 7.23744 15.5886 6.91203C15.2632 6.58662 14.7347 6.58662 14.4093 6.91203L9.99935 11.322L5.58937 6.91463C5.26396 6.58922 4.73549 6.58922 4.41007 6.91463C4.08466 7.24004 4.08466 7.76851 4.41007 8.09392L9.4084 13.0923L9.411 13.0896Z"
        fill="#5F6368"
      />
    </svg>
  );
};

export function VeCountry({
  register,
  name,
  style,
  value,
  setValue,
  required,
  onChangeData,
  disabled,
  onBlur,
  error,
  errorText,
  label = "Select a Country",
  sendCode = false,
  requiredLabel,
  blockedCountries = [],
}: {
  register?: any;
  name?: string;
  value?: string;
  style?: React.CSSProperties;
  setValue?: any;
  required?: boolean;
  onChangeData?: any;
  disabled?: boolean;
  onBlur?: any;
  error?: boolean;
  errorText?: string;
  label?: string;
  sendCode?: boolean;
  requiredLabel?: boolean;
  blockedCountries?: string[];
}) {
  const [country, setCountry] = useState({});
  const countryValue = () => {
    if (value !== undefined || value !== null) {
      const countryData = countries.filter(
        (val: any) => val[`${sendCode ? "code" : "label"}`] === value,
      )?.[0];
      setCountry(countryData as any);
    }
  };

  useEffect(() => {
    if (value !== undefined) countryValue();
    // else
    //   setCountry({
    //     code: "US",
    //     label: "United States",
    //     phone: "1",
    //     suggested: true,
    //   });
  }, [value]);

  return (
    <VeBox width={"100%"} display={"flex"} flexDirection={"column"}>
      <Autocomplete
        id="country-select-demo"
        popupIcon={<DropDownIcon />}
        options={countries?.filter(
          (item: any) => !blockedCountries.includes(item.code),
        )}
        disabled={disabled}
        value={country}
        sx={{
          ...style,
          width: "100%",
          "& .MuiOutlinedInput-root": {
            borderRadius: "4px !important",
          },
        }}
        {...(register && register(name))}
        autoHighlight
        onChange={(event, newCountry: any) => {
          if (onChangeData) {
            onChangeData(newCountry);
          }
          setCountry(newCountry);
          setValue(
            name || "country",
            sendCode ? newCountry?.code || "" : newCountry?.label || "",
            {
              shouldValidate: true,
              shouldDirty: true,
            },
          );
        }}
        onBlur={onBlur}
        getOptionLabel={(option) => option.label}
        renderOption={(props, option) => (
          <Box
            component="li"
            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
            {...props}
          >
            <img
              loading="lazy"
              width="20"
              srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
              src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
              alt="Flag"
            />
            <VeTypography variant="label2Secondary">
              {option?.label}
            </VeTypography>
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={
              required || requiredLabel ? (
                <VeBox
                  sx={{
                    color: "#3D465A !important",
                    "& .MuiInputLabel-root.Mui-disabled": {
                      color: "#8F9295 !important", // Replace with your desired disabled color
                    },
                  }}
                  display={"flex"}
                >
                  {label}
                  <VeBox marginLeft={"2px"} color={"red"}>
                    *
                  </VeBox>
                </VeBox>
              ) : (
                <VeBox
                  sx={{
                    color: "#3D465A !important",
                    "& .MuiInputLabel-root.Mui-disabled": {
                      color: "#8F9295 !important", // Replace with your desired disabled color
                    },
                  }}
                >
                  {label}
                </VeBox>
              )
            }
            sx={{
              "& .MuiOutlinedInput-input": {
                height: "7px",
              },
            }}
            inputProps={{
              ...params.inputProps,
              autoComplete: "new-password", // disable autocomplete and autofill
            }}
            error={error}
          />
        )}
      />
      {error && errorText && (
        <VeBox sx={{ lineHeight: "0px", marginTop: "3px" }}>
          <VeTypography
            style={{ marginLeft: "10px" }}
            variant="label4ErrorPrimary"
          >
            {errorText}
          </VeTypography>
        </VeBox>
      )}
    </VeBox>
  );
}
